import { Box, Typography } from '@material-ui/core';

export function GoldenPathSubHeader() {
  return (
    <Box paddingBottom={1}>
      <Typography variant="h4" gutterBottom>
        Documentation filtered on “Golden Path”
      </Typography>
    </Box>
  );
}
